// lib
import { useState, useEffect } from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'

// components
import { Checkbox } from 'primereact/checkbox'

import DataCentrifugeTotal from '@aytm/app/stats/page/sidebar/data-quality/DataCentrifugeTotal'

// styles
import style from '@aytm/app/stats/page/sidebar/data-quality/styles/DataCentrifugeSection.module.scss'

const DataCentrifugeSubVector = ({
  root,
  vector,
  item,
  statuses,
  interactive,
  runEnabled = true,
  onClick,
  onFetch
}) => {
  // Mirror the incoming status into local state and only re-render when this row's
  // status actually changes — keeps a single vector's update from re-rendering the whole list.
  const [itemStatus, setItemStatus] = useState(statuses[item.id] || null)

  // Below T0 the row is inert, same as its parent (CAPABILITY.SELECT_VECTORS).
  const inert = item.disabled || vector.disabled || !interactive

  // Depend on the whole status object, not just its string, so a re-run that keeps the same
  // status string but changes message / section_start / duration_sec still refreshes the mirror.
  useEffect(() => setItemStatus(statuses[item.id] || null), [statuses[item.id]])

  return (
    <div
      data-testid={`stat-data-quality-panel-dc-subvector-${vector.id}-${item.id}`}
      // vector-active gates hover/cursor styling: disabled rows still mount so they can show
      // their status badge, but they shouldn't look clickable.
      className={classNames(style.row, style.vector, style.subvector, {
        [style['vector-active']]: !inert
      })}
      onClick={inert ? null : event => onClick(event, vector, item)}
    >
      <div
        data-testid={`stat-data-quality-panel-dc-subvector-checkbox-${vector.id}-${item.id}`}
        className={`${style['vector-checkbox']} p-field`}
      >
        <Checkbox
          className="p-checkbox-sm"
          value={vector.text}
          checked={item.disabled || vector.disabled ? false : item.checked}
          disabled={inert}
        />
      </div>
      <div
        data-testid={`stat-data-quality-panel-dc-subvector-header-${vector.id}-${item.id}`}
        className={`${style['vector-header']} p-col`}
      >
        <span
          data-testid={`stat-data-quality-panel-dc-subvector-label-${vector.id}-${item.id}`}
          className={classNames(style['vector-button'], {
            [style[`vector-button-${itemStatus?.status.toLowerCase()}`]]: itemStatus,
            'p-disabled': vector.disabled
          })}
        >
          {item.text}
        </span>
      </div>
      <DataCentrifugeTotal
        root={root}
        vector={item}
        vectorStatus={itemStatus}
        interactive={interactive}
        runEnabled={runEnabled}
        onFetch={onFetch}
      />
    </div>
  )
}

DataCentrifugeSubVector.propTypes = {
  root: PropTypes.any,
  vector: PropTypes.object,
  item: PropTypes.object,
  statuses: PropTypes.object,
  interactive: PropTypes.bool,
  runEnabled: PropTypes.bool,
  onClick: PropTypes.func,
  onFetch: PropTypes.func
}

DataCentrifugeSubVector.displayName = 'DataCentrifugeSubVector'

export default DataCentrifugeSubVector
